import { render } from "./AiProcessTaskEditPage.vue?vue&type=template&id=12a68658"
import script from "./AiProcessTaskEditPage.vue?vue&type=script&lang=js"
export * from "./AiProcessTaskEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__